export enum CommunityType {
    HELPCENTER = 1,
    BLOG = 2
}